import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import { useDialog } from "@platform/store";
import { MarketingHireUsDialog, HireUsFormData } from "./MarketingHireUsDialog";
import { marketingEventBus } from "@platform/events/marketing.events";

/**
 * Container for MarketingHireUsDialog.
 * Handles dialog state, API submission, and event tracking.
 */
export function MarketingHireUsDialogContainer() {
  const { activeDialog, closeDialog } = useDialog();
  const isOpen = activeDialog === "hireUs";

  const submitForm = useMutation({
    mutationFn: async (data: HireUsFormData) => {
      marketingEventBus.emitEvent("hireUs:submit", data);

      return await apiRequest(
        "/marketing/contact/",
        "POST",
        {
          first_name: data.firstName,
          last_name: data.lastName,
          ...data,
          form_type: "hire_us",
        },
        false
      );
    },
    onSuccess: (_data, variables) => {
      marketingEventBus.emitEvent("hireUs:success", variables);
    },
  });

  const handleClose = () => {
    closeDialog();
  };

  return (
    <MarketingHireUsDialog
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={submitForm.mutateAsync}
    />
  );
}

